// Debug utility for monthly prize system
export function debugMonthlyPrizes(gameStore) {
  console.log('=== MONTHLY PRIZE DEBUG ===');
  
  // Check current state
  console.log('Current day:', gameStore.currentDay);
  console.log('Current month:', Math.floor((gameStore.currentDay - 1) / 32) + 1);
  console.log('Player inventory size:', gameStore.playerOwner?.inventory?.length || 0);
  console.log('Player chocobo IDs:', gameStore.playerOwner?.chocoboIds);
  
  // Check player chocobos' race history
  const playerChocobos = gameStore.chocobos.filter(c => 
    gameStore.playerOwner.chocoboIds.includes(c.id)
  );
  
  console.log('\n=== PLAYER CHOCOBOS RACE HISTORY ===');
  playerChocobos.forEach(chocobo => {
    console.log(`\n${chocobo.name} (ID: ${chocobo.id}):`);
    const recentRaces = chocobo.raceHistory?.slice(-5) || [];
    recentRaces.forEach(race => {
      const month = Math.floor((race.day - 1) / 32) + 1;
      console.log(`  - Day ${race.day} (Month ${month}): ${race.raceType} - ${race.finishTime}s (Position: ${race.position})`);
    });
  });
  
  // Check current month's best times
  const currentMonth = Math.floor((gameStore.currentDay - 1) / 32) + 1;
  console.log('\n=== CHECKING CURRENT MONTH BEST TIMES ===');
  
  const { MonthlyRaceManager } = require('@/services/monthlyRaceManager');
  const bestTimes = MonthlyRaceManager.getMonthlyBestTimes(gameStore.chocobos, currentMonth);
  
  Object.entries(bestTimes).forEach(([category, result]) => {
    console.log(`\n${category.toUpperCase()}:`);
    if (result.chocobo) {
      const isPlayerOwned = gameStore.playerOwner.chocoboIds.includes(result.chocobo.id);
      console.log(`  Winner: ${result.chocobo.name} (${isPlayerOwned ? 'PLAYER' : 'NPC'})`);
      console.log(`  Time: ${result.raw}s (normalized: ${result.normalized})`);
    } else {
      console.log('  No races in this category this month');
    }
  });
  
  // Force process month end to test
  console.log('\n=== FORCE PROCESSING MONTH END ===');
  const rewards = MonthlyRaceManager.processMonthEnd(gameStore);
  console.log('Rewards returned:', rewards);
  console.log('Inventory after processing:', gameStore.playerOwner?.inventory?.length || 0);
  
  // Check inventory contents
  console.log('\n=== INVENTORY CONTENTS ===');
  const inventory = gameStore.playerOwner?.inventory || [];
  inventory.forEach((item, idx) => {
    console.log(`${idx + 1}. ${item.name} (Type: ${item.type || 'unknown'})`);
  });
}

// Attach to window for console debugging
if (typeof window !== 'undefined') {
  window.debugMonthlyPrizes = debugMonthlyPrizes;
}